




















import { Component, Prop, Vue } from 'vue-property-decorator'
import utils from '@/libs/utils'
@Component
export default class OrderInfo extends Vue {
	@Prop({
		type: Object,
		required: false,
		default: () => {
			return {}
		}
	})
	private orderData!: any
	@Prop({
		type: Array,
		required: false,
		default: () => {
			return []
		}
	})
	private orderAttachments!: any
	private isBillState (state: any) {
		return (this as any).$fxStateMiddleware.stateIs('stateQuotes')(state)(this.orderData.bill_state)
	}
	private computedEndDateCell (inDate: any) {
		if (!inDate) {
			return ''
		}
		return utils.setDateTime(utils.newData(inDate), '时分')
	}
}
